var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-pagination',{staticClass:"pager mt-4",attrs:{"current-page":_vm.page,"page-size":_vm.pageSize,"background":"","disabled":_vm.disabledFlag,"page-sizes":_vm.pageSizes,"layout":_vm.layout,"total":_vm.total},on:{"current-change":_vm.changePage,"size-change":_vm.handleSizeChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }